import * as Yup from 'yup';

export const ListVehicleSchema = Yup.object().shape({
  vehicleCategory: Yup.string().required('Vehicle category is required'),
  plateNumber: Yup.string().required('License plate number is required'),
});

export interface ListVehicleDataType {
  vehicleCategory: string;
  plateNumber: string;
}

export const ListVehicleInitialValues: ListVehicleDataType = {
  vehicleCategory: '',
  plateNumber: '',
};

export interface ListVehicleInterface {
  vehicleCategory: string;
  plateNumber: string;
}


